// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"b23053f5","326":"f9b4fb88"}[chunkId] + ".chunk.css";
};